import { render, staticRenderFns } from "./LicenseReportDialog.vue?vue&type=template&id=55a8139d&"
import script from "./LicenseReportDialog.vue?vue&type=script&lang=ts&"
export * from "./LicenseReportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports